export default __webpack_public_path__ + "static/lighthouse-0f188162bcec33d702c2fec59942fd0e.webp";